module.exports = __webpack_public_path__ + "static/media/18ECA45.9d9742b5.jpg";